<template>

    <div class="iwd-modal standard-modal">
        <div class="modal-inner">
            <button class="close-modal" @click="closeModal()"></button>
            <div v-if="media.display" class="modal-media-el">
                <img v-if="media.img_src" :src="media.img_src">
            </div>
            <div class="modal-main-content" :class="{visible: mode === 'video'}">
                <vue-plyr ref="plyr" :options="playerOptions">
                    <video></video>
                </vue-plyr>
            </div>
            <div class="modal-main-content" :class="{visible: mode === 'standard'}" v-html="main_content">

            </div>
        </div>
    </div>

</template>

<script>

var emitter = require('tiny-emitter/instance');

    export default {
    	data(){
    		return {
    			mode: 'standard',
                media: {
                	display: false,
                    img_src: ''
                },
                main_content: '',

                playerOptions: {
                    controls: [
                        'progress',
                        'volume',
                        'play',
                        'fullscreen',
                        'settings'
                    ],
                    settings: [

                    ],
                    quality: {
                        'default': 720
                    },
                    storage: {
                        'enabled': false
                    }
                },
                is_playing: false,
                source: null
            }
        },
        mounted()
        {
        	emitter.on('showModal', (obj)=>{

                if(obj.video)
                {
                	this.mode = 'video';

                	// video preview popup
                    const modal = $('.standard-modal');
                    modal.css('display','flex').hide().fadeIn(600);

                    axios.get('/api/get-chapter-video/' + obj.id).then((response)=>{

                        this.$nextTick(()=> {
	                        this.player.source = response.data.source_data;
	                        this.player.play();
                        });

                        this.player.on('ended', ()=>{
                            this.closeModal();
                        });

                    }).catch((e) => {
                        if(e.response){
                            console.log(e.response.data.message);
                            console.log(e.response.data);
                            console.log(e.response.status);
                            console.log(e.response.headers);
                        }else {
                            throw new Error('An error occurred connecting with the server.');
                        }
                    });

                }else{
                	// else it's a standard info popup, with optional image
                    this.mode = 'standard';

                    const modal = $('.standard-modal');
                    modal.css('display','flex').hide().fadeIn(600);

                    this.media = obj.media;
                    this.main_content = obj.content;
                }

            });
        },
        methods: {
    		closeModal(){
        		this.media = {
        			display: false,
                    img_src: ''
                };
                if(this.mode === 'video')
                {
                    this.player.stop();
                    this.player.source = null;
                }
        		this.main_content = '';
        		const modal = $('.standard-modal');
        		modal.hide();
            }
        },
        computed: {
            player () {

                if(typeof this.$refs.plyr?.player === 'undefined' || this.$refs.plyr.player === null)
                {
                	return null;
                }
                return this.$refs.plyr.player;
            }
        }
    }

</script>
